module.exports = __webpack_public_path__ + "img/pin-fill.880a5b05.svg";